module.exports = __webpack_public_path__ + "static/media/plus.ed7fe54a.svg";